module.exports = __webpack_public_path__ + "static/media/country_dk.87242e01.webp";